import { CommonModule } from '@angular/common';

import { DocumentTemplateRoutingModule } from './document-template-form-routing.module';

// component
import { DocumentTemplateFormComponent } from './document-template-form.component';
import { FieldConfigComponent } from './field-config/field-config.component';
import { DialogFieldConfigComponent } from './dialog-field-config/dialog-field-config.component';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/core/material';

import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
} from '@angular/material';
import { DialogChangeNameFieldComponent } from './dialog-difference-process/dialog-change-name-field/dialog-change-name-field.component';
import { DialogGroupNameFieldComponent } from './dialog-difference-process/dialog-group-name-field/dialog-group-name-field.component';
import { DialogErrorComponent } from './dialog-error/dialog-error.component';
import { SignatureConfigComponent } from './signature-config/signature-config.component';
import { DialogSignatureConfigComponent } from './dialog-signature-config/dialog-signature-config.component';
import { ConfiguringSigninFlowComponent } from './configuring-signin-flow/configuring-signin-flow.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
@NgModule({
  declarations: [
    DocumentTemplateFormComponent,
    FieldConfigComponent,
    DialogFieldConfigComponent,
    DialogChangeNameFieldComponent,
    DialogGroupNameFieldComponent,
    DialogErrorComponent,
    SignatureConfigComponent,
    DialogSignatureConfigComponent,
    ConfiguringSigninFlowComponent
  ],
  imports: [
    CommonModule,
    DocumentTemplateRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MaterialModule,
    MatSortModule,
    MatTableModule,
    HttpClientModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    NgZorroAntdModule
  ],
  exports: [
    CdkTableModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatButtonModule,
  ],
  entryComponents: [DialogFieldConfigComponent, DialogGroupNameFieldComponent, DialogChangeNameFieldComponent, DialogErrorComponent, DialogSignatureConfigComponent],
})
export class DocumentTemplateFormModule { }
